Antonia Hoffmann  
Brockhausstr. 57  
04229 Leipzig  
[E-Mail](mailto:yoga-mit-antonia@posteo.de)   

Gemäß § 19 UStG bin ich als Kleinunternehmerin von der Umsatzsteuer befreit und weise diese daher nicht aus.
